export function buildQueryFromQueryConfig(queryConfig) {
    if (!queryConfig) {
        return queryConfig
    }
    if (queryConfig.startsWith("{")) {
        return buildQueryFromQueryGroup(JSON.parse(queryConfig))
    } else {
        return queryConfig
    }
}

export function buildQueryFromQueryGroup(queryGroup) {
    const query = []
    for (const child of queryGroup.children) {
        if (child.type === 'group') {
            const childQuery = buildQueryFromQueryGroup(child)
            if (childQuery) {
                query.push(childQuery)
            }
        } else if (child.type === 'field') {
            const childQuery = buildQueryFromQueryField(child)
            if (childQuery) {
                query.push(childQuery)
            }
        }
    }
    if (query.length === 0) {
        return null
    } else if (query.length === 1) {
        return query[0]
    } else {
        return query.map(item => '(' + item + ')').join(queryGroup.logic === 'and' ? ' AND ' : ' OR ')
    }
}

function buildQueryFromQueryField(queryField) {
    if (!queryField.field || !queryField.op || !queryField.value || !queryField.value.trim()) {
        return null
    }
    const parsedValue = parseQueryFieldValue(queryField.value)
    if (!parsedValue || parsedValue.length === 0) {
        return null
    }
    if (queryField.op === 'all') {
        if (parsedValue.length === 1) {
            return queryField.field + ':' + parsedValue[0]
        } else {
            return queryField.field + ':(' + parsedValue.join(' AND ') + ')'
        }
    } else if (queryField.op === 'any') {
        if (parsedValue.length === 1) {
            return queryField.field + ':' + parsedValue[0]
        } else {
            return queryField.field + ':(' + parsedValue.join(' OR ') + ')'
        }
    } else if (queryField.op === 'ne') {
        if (parsedValue.length === 1) {
            return "*:* NOT " + queryField.field + ':' + parsedValue[0]
        } else {
            return "*:* NOT " + queryField.field + ':(' + parsedValue.join(' OR ') + ')'
        }
    }
    return null
}

function parseQueryFieldValue(val) {
    if (!val) {
        return []
    }
    return val.trim().split(/\s+/).filter(item => item)
}

export function escapeQueryTerm(term) {
    return term.replace(/([ ()[\]\\"])/g, "\\$1")
}
